const RAW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://klugastro-backend.steamdeneme38.workers.dev';
export const API_BASE_URL = RAW_API_BASE_URL.replace(/\/+$/, '');

export const callPublicApi = async (endpoint, method = 'GET', body = null) => {
  try {
    const headers = {
      'Content-Type': 'application/json'
    };

    // Token Injection if logged in
    const token = localStorage.getItem('authToken') || localStorage.getItem('adminToken');
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
      headers['x-auth-token'] = token;
    }

    // Multi-Tenancy Injection
    const storedClubID = localStorage.getItem('selectedClubID');
    if (storedClubID) {
      headers['kulupID'] = storedClubID;
    }

    const options = { method, headers };
    if (body) {
      options.body = JSON.stringify(body);
    }

    // Ensure one slash between base and endpoint
    const base = API_BASE_URL.endsWith('/') ? API_BASE_URL : `${API_BASE_URL}/`;
    const ep = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    const url = `${base}${ep}`;

    const response = await fetch(url, options);

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      throw new Error(errData.error || errData.message || `API Hatası: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Public API isteği hatası (${endpoint}):`, error);
    throw error;
  }
};


export const callApi = async (endpoint, method = 'POST', body = null) => {
  try {
    const token = localStorage.getItem('authToken') || localStorage.getItem('adminToken');

    if (!token) throw new Error("Kullanıcı oturumu bulunamadı.");

    // Debug Token and API Key
    console.log(`[callApi] Token Length: ${token.length}, First 5: ${token.substring(0, 5)}...`);

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'x-auth-token': token
    };

    // Multi-Tenancy Injection
    const storedClubID = localStorage.getItem('selectedClubID');
    if (storedClubID) {
      headers['kulupID'] = storedClubID;
    }

    const options = { method, headers };
    if (body) {
      console.log("[callApi] Body before stringify:", body);
      options.body = JSON.stringify(body);
      console.log("[callApi] Request Body:", options.body);
    } else {
      console.log("[callApi] No body provided for", method, endpoint);
    }

    // Ensure one slash between base and endpoint
    const base = API_BASE_URL.endsWith('/') ? API_BASE_URL : `${API_BASE_URL}/`;
    const ep = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    const url = `${base}${ep}`;

    console.log(`Calling Admin API: ${method} ${url}`);

    const response = await fetch(url, options);
    if (!response.ok) {
      // Handle 401 specifically
      if (response.status === 401) {
        console.warn("Unauthorized access (401). clearing session and redirecting.");
        const errorText = await response.text();
        console.error("401 Error Body:", errorText);

        // Clear all auth data
        localStorage.removeItem('authToken');
        localStorage.removeItem('adminToken');
        localStorage.removeItem('user');

        window.location.href = "/login";
        throw new Error("Oturum süresi doldu. Lütfen tekrar giriş yapın ve bilgilerinizi kontrol edin.");
      }

      const errorData = await response.json();
      throw new Error(errorData.message || errorData.error || `API Hatası: ${response.status}`);
    }

    // Check if JSON or Text
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      try {
        const text = await response.text();
        return text ? JSON.parse(text) : {};
      } catch (e) {
        throw new Error("Geçersiz JSON Yanıtı: " + e.message);
      }
    } else {
      const text = await response.text();
      try {
        return text ? JSON.parse(text) : {};
      } catch (parseError) {
        console.error("JSON Parse Hatası. Gelen Veri:", text);
        // Eğer sadece basit bir string geldiyse (örn: "Başarılı") onu obje olarak dön
        return { message: text, raw: text };
      }
    }

  } catch (error) {
    console.error(`Secure API isteği hatası (${method} ${endpoint}):`, error);
    if (error.message === "Kullanıcı oturumu bulunamadı." || error.message.includes("Oturum süresi doldu")) {
      // Redundant safety clear
      localStorage.removeItem('authToken');
      window.location.href = "/login";
    }
    throw error;
  }
};


